import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MeasurementLogListComponent } from "../measurement-log-list/measurement-log-list.component";
import { DamageCase } from '../../../models/damage-case';
import { MeasurementLog } from '../../../models/measurement/measurement-log';

@Component({
  selector: 'app-measurement',
  standalone: true,
  imports: [MeasurementLogListComponent],
  templateUrl: './measurement.component.html',
  styleUrl: './measurement.component.scss'
})
export class MeasurementComponent implements OnInit {
  @Input() case!: DamageCase

  ngOnInit(): void {
    this.case = history.state.caseObject;
  }
}
